import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import {
  GetSingle,
  Delete,
} from "../../../../../../../../src/features/admin/quality_management/process_requirement/complaint/Slice";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useDispatch, useSelector } from "react-redux";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import Image_Show_Modal from "../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import Multi_Image_Show_Modal from "../../../../../../../common/common_modal/multiimage_show_modal/multiimage_show_modal";

function Complaints_table({
  complaintsdetails,
  onEdit,
  ondelete,

  refreshData,
}) {
  const data = complaintsdetails?.data || [];

  const [currentPage, setCurrentPage] = useState(
    complaintsdetails?.current_page || 1,
  );

  const [show, setShow] = useState(false);
  const [showData, setShowData] = useState("");

  const totalPages = complaintsdetails?.total_pages || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(FixIDS.complaint.Edit);
  const haveDeletePermission = permissions?.includes(FixIDS.complaint.Delete);
  const haveViewPermission = permissions?.includes(FixIDS.complaint.View);

  return (
    <section className="Imperiality_table">
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped customer_table">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Sample ID</th>
                <th>Customer Name</th>
                <th>Customer ID</th>
                <th>Contact No.</th>
                <th>Nature Of Complaint</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={row.id || index}>
                    <td>
                      {(currentPage - 1) *
                        (complaintsdetails?.per_page || data.length || 0) +
                        index +
                        1}
                    </td>
                    {/* <td>
                      {row.updatedAt
                        ? new Date(row.updatedAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "---"}
                    </td> */}
                    <td>{formatDate(row?.createdAt)}</td>

                    <td>{row.Sample_Management?.unique_id || "---"}</td>

                    <td>{row.customer_name || "---"}</td>

                    <td>{row.User?.name || "---"}</td>

                    <td>{row.contact_person_contact_no || "---"}</td>

                    <td>{row.Nature_Of_Complaint?.name || "---"}</td>

                    <td>{row.remark || "---"}</td>

                    <td
                      className={
                        row.Complaint_Status?.name === "Pending"
                          ? "status_pending"
                          : "status_completed"
                      }
                    >
                      {row.Complaint_Status?.name || "---"}
                    </td>

                    <td>
                      <div className="action_icons">
                        {haveViewPermission && (
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() => {
                              setShow(true);
                              setShowData(row);
                            }}
                          />
                        )}

                        {haveEditPermission && (
                          <FontAwesomeIcon
                            icon={faPen}
                            onClick={() => onEdit(row.id)}
                            style={{ cursor: "pointer" }}
                          />
                        )}

                        {haveDeletePermission && (
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            onClick={() => ondelete(row.id)}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No Complaints Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {data.length} of {complaintsdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <Multi_Image_Show_Modal
        onHide={() => setShow(false)}
        show={show}
        showData={showData}
        imgSrc={showData?.Complaints_Files}
      />
    </section>
  );
}

export default Complaints_table;
